import {useDispatch, useSelector} from "react-redux";
import {fetchInvoices} from "../store/actions/invoicesActions";

const useFilter = () => {
    const dispatch = useDispatch();
    const globalFilters = useSelector((state) => state.filters);

    const changeFilter = (key, value) => {
        dispatch({
            type: "SET_FILTER",
            payload: { key, value },
        });

        const updatedFilters = {
            ...globalFilters,
            [key]: value
        };
        dispatch(fetchInvoices(updatedFilters));
    };

    return {
        filters: globalFilters,
        changeFilter,
    };
};

export default useFilter;
